import { usePage } from "@inertiajs/react"
import LocationCards, { type LocationCard } from "@/components/LocationCards"
import type { PageProps } from "@/types/inertia"
import { BrandMotif } from "@/components/ui/brand-motif"

interface Props {
  sites: LocationCard[]
}

export default function HomeLocations({ sites }: Props) {
  const { translations } = usePage<PageProps>().props
  const t = translations.home.locations

  // Until a location exists the band still stands, on the two we know.
  const display = sites.length > 0
    ? sites
    : [
        { id: 1, slug: "prestwich", name: "Prestwich", region: "Prestwich, Manchester", address: "Oakhill Court, 171 Bury New Road, Prestwich, M25 9ND", maps_url: null, primary_photo_url: null, href: "/prestwich" },
        { id: 2, slug: "hebden-bridge", name: "Hebden Bridge", region: "Hebden Bridge, West Yorkshire", address: "36 Market Street, Hebden Bridge, HX7 6AA", maps_url: null, primary_photo_url: null, href: "/hebden-bridge" },
      ]

  return (
    <section className="relative overflow-hidden bg-cream py-20">
      <BrandMotif variant="sprig" className="absolute -bottom-10 left-6" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2>{t.title}</h2>
          <p className="mt-3 text-ink-muted">{t.subtitle}</p>
        </div>

        <LocationCards sites={display} />
      </div>
    </section>
  )
}
